// extracted by mini-css-extract-plugin
export default {"ged":"ged_ged__wklSs"};